<template>
  <AppPopover
    ref="AppPopover"
    class="overtime-popover"
    placement="top"
    lazy
    :popover-container-classes="popoverContainerClasses"
  >
    <template #body>
      <div class="p-10">
        <div class="strong pr-20">{{ title }}</div>
        <div class="marketing-text-gray-light">
          <div
            v-for="(text, i) in texts"
            :key="i"
          >
            {{ text }}
          </div>
        </div>
      </div>
    </template>
    <template #trigger>
      <i
        class="fa fa-clock-o text-overtime js-overtime hi-14"
        role="button"
        :class="iconClasses"
      />
    </template>
  </AppPopover>
</template>

<script>
import AppPopover from '~/components/AppPopover.vue';
import { formatDuration } from '~/utils/time_utils';

export default {
  name: 'ReportOvertimePopover',
  components: {
    AppPopover,
  },
  props: {
    title: { type: String, default: 'Weekly overtime' },
    overtime: { type: [Array, Object], required: true },
    iconClasses: { type: String, default: '' },
    popoverContainerClasses: { type: String, default: '' },
    showFinancial: { type: Boolean, default: false },
    currency: { type: Object, default: () => {} },
  },
  computed: {
    texts() {
      return []
        .concat(this.overtime)
        .filter(Boolean)
        .map((row) => {
          const s = this.showFinancial && row.overtimeRate !== false;
          const formattedOvertime = formatDuration(row.overtime, { showSeconds: 'never' });

          return s
            ? [
                formattedOvertime,
                ' at ',
                row.overtimeRate.formatMoney({ ...(this.currency || row.currency), strip_insignificant_zeros: true }),
                '/hr',
              ].join('')
            : formattedOvertime;
        });
    },
  },
};
</script>
